// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__rA_0Y","calendarButtons":"ClockData_calendarButtons__1M8X3"};